import validators from '../utils/validators';

class Anamnesis {
  /**
   * @param data
   */
  constructor(data) {
    const properties = {
      id: (v) => validators.isNotEmptyString(v),
      user: (v) => validators.isNotEmptyString(v),
      text: (v) => validators.isString(v),
      date: (v) => validators.isValidDate(v),
      createdBy: (v) => validators.isStringOrNull(v),
    };

    for (const property of Object.keys(properties)) {
      if (properties[property](data[property]) !== true) {
        throw new Error(`Invalid property ${property} in ${data.id}`);
      }

      if (['date'].includes(property)) {
        this[property] = new Date(data[property]);
      } else {
        this[property] = data[property];
      }
    }
  }
}

export default Anamnesis;
